import React from 'react';
import { useSignature } from '../../contexts/SignatureContext';

interface GridArchetypeProps {
  title: string;
  subtitle?: string;
  filterPanel?: React.ReactNode;
  gridActions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * ARQUÉTIPO 3: GRID
 * Destinado a pesquisas, consultas, filtros densos (inputs 28px) e tabelas de dados.
 */
export const GridArchetype: React.FC<GridArchetypeProps> = ({
  title,
  subtitle,
  filterPanel,
  gridActions,
  children,
}) => {
  const { colors, densities } = useSignature();

  return (
    <div
      className="flex-1 flex flex-col h-full overflow-hidden"
      style={{
        backgroundColor: colors.bgApp,
        color: colors.textPrimary,
        padding: `${densities.paddingMainPx}px`,
      }}
    >
      <div className="flex-1 flex flex-col max-w-7xl mx-auto w-full space-y-4 overflow-hidden">
        {/* Header do GRID */}
        <header className="flex items-center justify-between pb-3 border-b shrink-0" style={{ borderColor: colors.border }}>
          <div>
            <h1 className="text-lg sm:text-xl font-bold tracking-tight" style={{ color: colors.textPrimary }}>
              {title}
            </h1>
            {subtitle && (
              <p className="text-xs mt-0.5" style={{ color: colors.textSecondary }}>
                {subtitle}
              </p>
            )}
          </div>
          {gridActions && <div className="flex items-center gap-2">{gridActions}</div>}
        </header>

        {/* Paper de Filtros Compacto (Regra 15: p-2, mb-2) */}
        {filterPanel && (
          <div
            className="p-3 rounded-2xl border shadow-xs shrink-0"
            style={{
              backgroundColor: colors.bgSurface,
              borderColor: colors.border,
            }}
          >
            {filterPanel}
          </div>
        )}

        {/* Área Principal da Tabela / Grid Rolável */}
        <div
          className="flex-1 rounded-2xl border overflow-hidden shadow-sm flex flex-col"
          style={{
            backgroundColor: colors.bgSurface,
            borderColor: colors.border,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
